// extracted by mini-css-extract-plugin
export var accordion = "_b4-0";
export var chevron = "_b4-3";
export var closed = "_b4-2";
export var content = "_b4-4";
export var open = "_b4-1";
export var rotate = "_b4-5";